/**
 * Created by hernanherreros on 2019-05-09
 */

import * as React from 'react'
import { RouteComponentProps } from 'react-router'
import { flowRight } from 'lodash'
import Form, { Values } from 'react-trazo-forms'
import {
  getInformationFields,
  informationInitialValues,
  informationValidationSchema,
} from '../../forms/wizard/information'
import withCongress, { ComponentProps } from '../../providers/Congress/withCongress'
import withReservation, { ReservationProps } from '../../providers/Reservation/withReservation'
import { RouterItem } from '../../config/router.config'
import withWizardProps, { WizardProps } from '../../wrappers/withWizardParams'
import { getReservation, purchase, saveRegistration } from '../../requests/inscription'
import { uploadPDF } from '../../requests/gallery'
import { getNextWizardPath } from '../../helpers/wizard'
import { message, Upload, Button, Icon, Spin } from 'antd'
import DetailResolver from '../../components/Resolvers/DetailResolver'
import LoaderWrapper from '../../components/Utils/LoaderWrapper'
import Row from '../../components/Form/Row'
import Section from '../../components/Section/Section'
import Col from '../../components/Form/Col'
import CustomButton from '../../components/Utils/Button'
import withURLParams, { URLParamsComponentProps } from '../../providers/URLParams/withURLParams'
import styled from 'styled-components'
import PhoneInput, { parsePhoneNumber, isValidPhoneNumber} from 'react-phone-number-input'
import { countryWithCode } from '../../helpers/forms'
import { HTML5_FMT } from 'moment'
import ButtonPriceModal from '../../components/Modals/ButtonPriceModal'

interface Props extends ComponentProps, RouteComponentProps, WizardProps, ReservationProps, URLParamsComponentProps {
  step: RouterItem;
  nextStep: RouterItem;
}

interface FormValues {
  Email?: any,
  FirstName?: any,
  LastName?: any,
  Country?: any,
  Region?: any,
  CompanyName?: any,
  JobTitle?: any,
  Gender?: any,
  AgeRange?: any,
  Voucher?: string,
  Phone?: any,
  Becado?: any,
}


interface State {
  values: FormValues,
  isValid: boolean,
  isLoading: boolean,
  prices: any,
  isInitialValid: boolean,
  file: string,
  pdfLoading: any,
  phone: any,
  isValidPhone: boolean,
  tempFile: any,
  fileName: string,
}

class Information extends React.Component<Props, State> {
  state = {
    values: {
      Email: null,
      FirstName: null,
      LastName: null,
      Country: null,
      Region: null,
      CompanyName: null,
      JobTitle: null,
      Gender: null,
      AgeRange: null,
      CouponCode: null,
      Voucher: "",
      Phone: null,
      Becado: "PAGADO PARTICULAR",
    },
    phone: null,
    isValid: true,
    isLoading: false,
    prices: [],
    isInitialValid: false,
    file: "",
    pdfLoading: false,
    isValidPhone: false,
    tempFile: "",
    fileName: "",
  }


  componentDidMount () {
    const { values } = this.state
    console.log("Values: ", values)
    console.log("Values.Phone: ", values.Phone)
    const isPhoneValid = values.Phone !== "" && isValidPhoneNumber(values.Phone || "") ? true : false
    this.setState({ isValidPhone: isPhoneValid})
  }

  beforeUpload = (e: any) => {
    this.handleUploadFile(e.target.files[0])
  }

  handlePhoneNumber = (val: any) => {
    let number = val ? val : ""
    const numb = parsePhoneNumber(number)
    console.log("is ok", numb)
    const isValid = val && isValidPhoneNumber(val) ? true : false
    this.setState({ phone: val, isValidPhone: isValid})
  }

  handleDownload = () => {
    window.open(`https://cdn.trazolabs.com/trazoevents/veterinario/Formulario-hotel.pdf`, '_blank')
  }

  handleUploadFile = async (val: any)=> {
    const { reservation } = this.props
    try {
      this.setState({ pdfLoading: true })
      await this.setState({ tempFile: val, fileName: val.name })
      const formData = new FormData()
      formData.append('CongressSlug', reservation.data.CongressSlug )
      formData.append('File', val, val.name )
      const resp = await uploadPDF( null, formData)
      this.setState({file: resp.Data.URL})
    }catch(e) {
      console.log('err', e)
    } finally {
      this.setState({ pdfLoading: false })
    }
  }

  handleFormSubmit = async() => {
    const { values, file, phone, tempFile, fileName } = this.state
    const { wizard, reservation, congress } = this.props
    this.setState({ isLoading: true })

    const copyOfValues = { ...values }
    copyOfValues.Voucher = file ? file : values.Voucher
    copyOfValues.Phone = phone

    // const priceUUID = copyOfValues.PriceUUID
    // delete copyOfValues.PriceUUID
    saveRegistration({ id: wizard.token }, {
      Information: copyOfValues,
      Country: values.Country,
      Becado: values.Becado,
      // PriceUUID: priceUUID,
    })
      .then(async (resp: any) => {
        if (congress.Slug != "veterinario-virtual-2022"){
          const formData = new FormData()
          formData.append('FinishingSource', 'forms' )
          formData.append('PaymentMethod', 'None' )
          if (copyOfValues.CouponCode) {
            formData.append('CouponCode', copyOfValues.CouponCode || "" )
          }
          if (tempFile && fileName) {
            formData.append('File', tempFile, fileName )
          }
          purchase({ id: wizard.token }, formData)
          .then((resp) => {
            this.handleSuccess()
          })
          .catch((resp: any) => {
            if(resp.message === 'coupon: record not found') {
              message.error('El código de cortesía ingresado ya se registró o no existe')
            } else {
              message.error(resp.message)
            }
          })
          .finally(() => {
            this.setState({ isLoading: false })
          })
        } else {
          this.handleSuccess()
        }
      })
      .catch((resp: any) => {
        message.error(resp.message)
      })
      .finally(() => {
        this.setState({ isLoading: false })
      })
  }

  handleSuccess = () => {
    const { history, wizard, congress, step } = this.props
    const nextPath = getNextWizardPath(wizard.token, congress.Slug, step.slug)
    history.push(nextPath)
  }

  handleResolve = async (data: any, callback: () => void) => {
    try {
      // await this.getPriceList()
      const isValid = await informationValidationSchema.validate(data.Data)
      this.setState({ isInitialValid: true, phone: data.Data.Phone || "" })
    } catch (e) {
      console.log('Initial data is not valid', e)
    } finally {
      callback()
    }
  }

  render () {
    const { reservation } = this.props

    return (
      <DetailResolver
        requestFunction={() => getReservation({ id: reservation.data.UUID })}
        render={this.renderContent}
        onResolve={this.handleResolve}
      />
    )
  }

  renderContent = (data: any) => {
    const { isLoading, isInitialValid, pdfLoading, values } = this.state
    const { congress } = this.props
    const index = countryWithCode.findIndex((country) => country.nombre == values.Country)
    const countryCode = countryWithCode[Math.max(index, 0)].iso2.toString()
    return (
      <LoaderWrapper isLoading={isLoading || pdfLoading}>
        <Form
          initialValues={informationInitialValues(data.Data)}
          fields={getInformationFields(congress.Slug)}
          validationSchema={informationValidationSchema}
          onChange={(values: Values, isValid: boolean) => this.setState({ values, isValid })}
          isInitialValid={isInitialValid}
        >
          {this.renderForm(data.Data, countryCode)}
        </Form>
      </LoaderWrapper>
    )
  }

  renderForm = (data: any, countryCode: any) => () => {
    const { file, phone, values } = this.state
    const { congress } = this.props

    let source = file ? file : values.Voucher && values.Voucher !== "" ? values.Voucher : ""
    console.log("source: ", source)
    if (source.endsWith("pdf")) {
      source = ""
    }

    console.log("Source: ", source)
    return (
      <React.Fragment>
        <Section>
          <h2>Datos Personales</h2>

          <Row gutter={32} m={15}>
            <Col md={12}>
              <div>Nombre Completo:</div>
              <h3 style={{ fontWeight: 600, color: '#4b5c6b' }}>{data.FirstName + ' ' + data.LastName}</h3>
            </Col>
            <Col md={12}>
              <div>Correo Electrónico Principal:</div>
              <h3 style={{ fontWeight: 600, color: '#4b5c6b' }}>{data.Email}</h3>
            </Col>
          </Row>
        </Section>

        <Section>
          <Row gutter={32}>
            <Col md={12}>
              <Form.Field name="Country"/>
            </Col>
            {congress.Slug === "veterinario-cartagena-2023" ? (
              <Col md={12}>
                <p>Número de Teléfono:</p>
                
                <PhoneInput
                  defaultCountry={countryCode || 'CL'}
                  placeholder="Ingresar número sin el código del país"
                  // countrySelectProps={{ unicodeFlags: true }}
                  value={phone || ""}
                  onChange={(val: any) => this.handlePhoneNumber(val)}
                  international
                  countryCallingCodeEditable={false}
                  />
                  <br/>
              </Col>
            ) : (
              <Col md={12}>
                <Form.Field name="Region"/>
              </Col> 
            )}
            
          </Row>
        </Section>

        <Section>
          <Row gutter={32}>
            <Col md={12}>
              <Form.Field name="AgeRange"/>
            </Col>
            <Col md={12}>
              <Form.Field name="Gender"/>
            </Col>
          </Row>
        </Section>

        <Section>
          <Row gutter={32}>
            <Col md={12}>
              <Form.Field name="JobTitle"/>
            </Col>

            <Col md={12}>
              <Form.Field name="CompanyName"/>
            </Col>
          </Row>
        </Section>
       {congress.Slug !== "veterinario-cartagena-2023" ? (
        <Section>
          <Row gutter={32}>
            <Col md={12}>
            <p>Número de Teléfono:</p>
            
            <PhoneInput
              defaultCountry={countryCode || 'CL'}
              placeholder="Ingresar número sin el código del país"
              // countrySelectProps={{ unicodeFlags: true }}
              value={phone || ""}
              onChange={(val: any) => this.handlePhoneNumber(val)}
              international
              countryCallingCodeEditable={false}
              />
               <br/>
            </Col>
           
            <Col md={12} />
          </Row>
        </Section> 
       ) : null}

        <Section>
          <Row gutter={32}>
            <Col md={12}>
              <Form.Field name="Becado"/>
            </Col>
           <Col md={12} />
          </Row>
        </Section>

        {congress.Slug === "veterinario-panama-2024" ? (
          <Section>
            <Row gutter={32}>
              <Col md={8}>
                <VoucherContainer>
                  <Label>Por favor, si no tiene beca, suba el comprobante de su transferencia o pago.</Label>
                  
                </VoucherContainer>
                <form method="post" encType="multipart/form-data" style={{ width: "100%", marginBottom: 22}}>
                  <input type="file" className="custom-file-input" onChange={this.beforeUpload}/>
                </form>
                {file !== "" || values.Voucher !== "" && source !== "" ? <a href={source} target='blank' > <img src={source} style={{ height: 50, borderRadius: 8 }}/></a> : null}
                {file !== "" || values.Voucher !== "" ? <h4>¡Archivo cargado!</h4> : <h4/>}
              </Col>  
              <Col md={16} style={{ alignSelf: "flex-start"}}>
                <ButtonContainer>
                  <ButtonPriceModal buttonText="Ver Precios congreso"/>
                </ButtonContainer>
              </Col>
            </Row>
          </Section>
        ) : null}

        
        {/* <Section>
          <Row gutter={32}>
            <Col md={12} style={{ marginBottom: '24px'}}>
              <strong>
                ¡Atención! Si te vas a hospedar en el hotel Santa Cruz es Obligatorio descargar
                el siguiente formulario, imprimir, rellenar a mano y presentarlo al momento de ingresar
              </strong>
            </Col>
            <Col md={12} style={{ marginBottom: '24px'}}>
              <CustomButton
                color={congress.PrimaryColor}
                onClick={this.handleDownload}>
                Descargar formulario
              </CustomButton>
            </Col>
          </Row>
        </Section> */}

        {this.renderActionButton(data)}
      </React.Fragment>
    )
  }

  renderActionButton (data: any) {
    const { isValid, isLoading, values, isValidPhone, phone, file } = this.state
    const { congress, nextStep } = this.props
    var message = 'Algunas respuestas son inválidas o no están completas'

    console.log("VAlues: ", values)
    console.log("isValidPhone: ", isValidPhone)
    console.log("isValid: ", isValid)
    if (values.Country === undefined) {
      message = 'Por favor seleccione un país'
    } else if (congress.Slug !== "veterinario-cartagena-2023" && values.Country === 'Chile' && values.Region === undefined) {
      message = 'Por favor seleccione una región'
    } else if (values.AgeRange === undefined) {
      message = 'Por favor seleccione su rango etario'
    } else if (values.JobTitle === '' || !values.JobTitle) {
      message = 'Por favor ingrese su cargo'
    } else if (values.CompanyName === '' || !values.CompanyName) {
      message = 'Por favor ingrese su organización o empresa'
    } else if (phone === '') {
      message = 'Por favor ingrese su número de teléfono'
    } else if (!isValidPhone && values.Phone === "") {
      message = 'El número de teléfono ingresado no es válido'
    }
    // this is opcional for now
    // else if (file === "" && values.Voucher === "" && congress.Slug == "veterinario-chile-2023") {
    //   message = 'Por favor suba comprobante de transferencia'
    // }

    // let hasVoucher = file !== "" || values.Voucher === ""
    // if (congress.Slug !== "veterinario-chile-2023" ) {
    //   hasVoucher = true
    // }
    return (
      <Section align="center">
        <CustomButton
          disabledMessage={message}
          color={congress.PrimaryColor}
          disabled={isLoading || !isValidPhone && values.Phone === "" }
          onClick={this.handleFormSubmit}>
          {nextStep.nextButtonLabel}
        </CustomButton>
      </Section>
    )
  }
}

const Label = styled.p`
  color: rgba(0, 0, 0, 0.85);
  text-align: left;
  position: relative;
  line-height: 39.9999px;
  white-space: nowrap;
  margin: 0;
`

const VoucherContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: start;
  
  @media screen and (max-width: 768px) {
    flex-direction: col !important;
    justify-content: start;
  }
`

const ButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: start;
  align-self: flex-start;
  margin-top: 41px;

  @media screen and (max-width: 768px) {
    margin-bottom: 30px;
    margin-top: 20px;
    justify-content: center;
  }
`

export default flowRight([withCongress, withWizardProps, withReservation, withURLParams])(Information)
